import { render, staticRenderFns } from "./stockMonitorPanel.vue?vue&type=template&id=6d71c6d9&scoped=true"
import script from "./stockMonitorPanel.vue?vue&type=script&lang=js"
export * from "./stockMonitorPanel.vue?vue&type=script&lang=js"
import style0 from "./stockMonitorPanel.vue?vue&type=style&index=0&id=6d71c6d9&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d71c6d9",
  null
  
)

export default component.exports